<template>
  <section class="hero-fondo" ref="sectionRef">
    <div class="hero-bg"></div>
    <div class="hero-overlay"></div>

    <div class="hero-container-grid">
      
      <div class="hero-col-texto">
        <span class="hero-tagline" ref="tagline">Tu gran noche comienza aquí</span>
        
        <div class="contenedor-titulos">
          <h1 class="hero-titulo" ref="titulo1">INVITACIONES</h1>
          <h2 class="hero-titulo-magic" ref="titulo2">Digitales Premium</h2>
        </div>

        <p class="hero-subtitulo" ref="subtitulo">
          Diseños exclusivos que transforman tus XV años <br class="desktop-only" />
          en una experiencia digital inolvidable.
        </p>

       <div ref="botonRef">

  <button
    class="hero-boton"
    @click="irADescripcion"
  >
    Ver Diseños Exclusivos
  </button>

</div>
      </div>

      <div class="hero-col-mockup" ref="mockupRef">
        <div class="smartphone-device">
          <div class="device-notch"></div>
          
          <div class="device-screen">
            <div 
              v-for="(invitacion, index) in invitaciones" 
              :key="index"
              class="invitacion-slide"
              :class="{ 'slide-activa': index === currentSlide }"
              :style="{ backgroundImage: `url(${invitacion.imagen})` }"
            >
              <div class="slide-overlay"></div>
            </div>
          </div>

          <div class="mockup-url-wrapper">
            <span class="mockup-url" ref="urlRef"></span>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'HeroQuinceanerasPremium',
  setup() {
    const sectionRef = ref(null)
    const tagline = ref(null)
    const titulo1 = ref(null)
    const titulo2 = ref(null)
    const subtitulo = ref(null)
    const botonRef = ref(null)
    const urlRef = ref(null)
    const mockupRef = ref(null)

    const currentSlide = ref(0)
const irADescripcion = () => {

  const seccion = document.getElementById('descripcion-section')

  if (seccion) {

    seccion.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })

  }
}
    // 1. RUTA DE TUS INVITACIONES: Reemplaza estos assets por las capturas reales de tus diseños
    const invitaciones = [
      { url: 'mis15.sofia-garcia.com', imagen: require('@/assets/DSC01734.webp') },
      { url: 'valentina.misquince.la', imagen: require('@/assets/DSC01734.webp') },
      { url: 'mis15.camila-mendoza.com', imagen: require('@/assets/DSC01734.webp') }
    ]

    // Efecto de máquina de escribir y cambio de diapositiva sincronizado
    const typeURL = (text, i = 0) => {
      if (!urlRef.value) return
      
      if (i < text.length) {
        urlRef.value.textContent = text.substring(0, i + 1)
        setTimeout(() => typeURL(text, i + 1), 60)
      } else {
        // Tiempo que se queda visible la URL antes de cambiar
        setTimeout(() => {
          gsap.to(urlRef.value, {
            opacity: 0,
            duration: 0.4,
            onComplete: () => {
              urlRef.value.textContent = ''
              gsap.set(urlRef.value, { opacity: 1 })
              
              // Cambiar al siguiente diseño de invitación de forma fluida
              currentSlide.value = (currentSlide.value + 1) % invitaciones.length
              
              // Iniciar el tipeo de la siguiente URL
              typeURL(invitaciones[currentSlide.value].url)
            }
          })
        }, 2500)
      }
    }

    onMounted(() => {
      // Fuentes tipográficas modernas
      const link = document.createElement('link')
      link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Montserrat:wght@300;400;600;700&display=swap'
      link.rel = 'stylesheet'
      document.head.appendChild(link)

      // TIMELINE PRINCIPAL (Animaciones cinemáticas de entrada)
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.value,
          start: 'top 80%',
          once: true
        }
      })

      // Revelado del fondo
      tl.from('.hero-bg', {
        scale: 1.15,
        duration: 2,
        ease: 'power2.out'
      })
      // Entrada del Tagline
      .from(tagline.value, {
        opacity: 0,
        y: -25,
        duration: 0.8,
        ease: 'power3.out'
      }, '-=1.4')
      // Revelado de títulos masivos
      .from([titulo1.value, titulo2.value], {
        opacity: 0,
        y: 40,
        rotateX: -10,
        stagger: 0.15,
        duration: 1,
        ease: 'power4.out'
      }, '-=1.1')
      // Aparición del subtítulo
      .from(subtitulo.value, {
        opacity: 0,
        y: 20,
        duration: 0.8,
        ease: 'power2.out'
      }, '-=0.7')
      // Botón CTA
      .from(botonRef.value, {
        opacity: 0,
        scale: 0.9,
        duration: 0.6,
        ease: 'back.out(1.5)'
      }, '-=0.5')
      // Entrada en 3D del Smartphone desde la derecha
      .from(mockupRef.value, {
        opacity: 0,
        x: 80,
        rotationY: -20,
        scale: 0.95,
        duration: 1.4,
        ease: 'power3.out',
        onComplete: () => {
          // Iniciar ciclo de URLs e Invitaciones
          typeURL(invitaciones[0].url);
          
          // Efecto de flotación infinita premium (Parallax sutil)
          gsap.to('.smartphone-device', {
            y: '-=15',
            rotationZ: '+=1',
            duration: 3.5,
            ease: 'sine.inOut',
            yoyo: true,
            repeat: -1
          })
        }
      }, '-=1.2')
    })

    return {
      sectionRef,
      tagline,
      titulo1,
      titulo2,
      subtitulo,
      botonRef,
      urlRef,
      mockupRef,
      invitaciones,
      irADescripcion,
      currentSlide
    }
  }
}
</script>

<style scoped>
/* Contenedor Base */
.hero-fondo {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #0b090a;
  padding: 80px 4%;
  box-sizing: border-box;
}

/* Imagen de fondo */
.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/principal.jpg');
  background-size: cover;
  background-position: center;
  z-index: 0;
}

/* Capa de degradado profesional */
.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(11, 9, 10, 0.98) 40%, rgba(240, 178, 188, 0.15) 100%);
  z-index: 1;
}

/* Grid de dos columnas para pantallas de escritorio */
.hero-container-grid {
  position: relative;
  z-index: 2;
  margin-top:90px;
  width: 100%;
  max-width: 1200px;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 40px;
  align-items: center;
}

.hero-col-texto {
  color: #ffffff;
  text-align: left;
}

.hero-col-mockup {
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 1200px; /* Brinda profundidad 3D */
}

/* --- ESTILIZADO DE TIPOGRAFÍAS --- */
.hero-tagline {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 4px;
  color: #f0b2bc;
  display: inline-block;
  margin-bottom: 1rem;
}

.contenedor-titulos {
  perspective: 1000px;
}

.hero-titulo {
  font-family: 'Montserrat', sans-serif;
  font-size: 3.5rem;
  font-weight: 700;
  letter-spacing: 2px;
  line-height: 1.1;
  margin: 0;
}

.hero-titulo-magic {
  font-family: 'ludovica', serif;
  font-size: 4.2rem;
  font-weight: 400;
  font-style: italic;
  line-height: 1;
  margin: 0 0 1.5rem 0;
  background: linear-gradient(45deg, #f0b2bc, #fff3f5, #e293a0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-subtitulo {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.1rem;
  font-weight: 300;
  line-height: 1.7;
  margin-bottom: 2.5rem;
  color: #e5e5e5;
}

/* Botón con microinteracción */
.hero-boton {
  background: linear-gradient(45deg, #e293a0, #f0b2bc);
  color: #1a1617;
  padding: 16px 40px;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  box-shadow: 0 10px 25px rgba(240, 178, 188, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;
}

.hero-boton:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(240, 178, 188, 0.5);
  background: linear-gradient(45deg, #f0b2bc, #fff3f5);
}

/* --- SMARTPHONE VIRTUAL PREMIUM --- */
.smartphone-device {
  position: relative;
  width: 290px;
  height: 580px;
  background: #1e1b1c;
  border-radius: 40px;
  border: 12px solid #2d2627; /* Marco del celular */
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.8), inset 0 0 10px rgba(0,0,0,0.5);
  overflow: hidden;
  transform-style: preserve-3d;
}

/* Cámara frontal / Notch moderno */
.device-notch {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 110px;
  height: 18px;
  background: #2d2627;
  border-radius: 20px;
  z-index: 10;
}

/* Pantalla interna */
.device-screen {
  position: relative;
  width: 100%;
  height: 100%;
  background: #110e0f;
  z-index: 2;
}

/* Slides de tus invitaciones */
.invitacion-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center top;
  opacity: 0;
  transform: scale(1.05) translateY(10px);
  transition: opacity 0.8s cubic-bezier(0.4, 0, 0.2, 1), transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Clase activa gestionada por Vue + CSS */
.invitacion-slide.slide-activa {
  opacity: 1;
  transform: scale(1) translateY(0);
}

.slide-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 35%;
  background: linear-gradient(180deg, transparent 0%, rgba(11, 9, 10, 0.7) 100%);
}

/* Widget de barra de dirección de internet flotante */
.mockup-url-wrapper {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 85%;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  padding: 10px 14px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  z-index: 5;
  text-align: center;
  box-sizing: border-box;
}

.mockup-url {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  color: #1a1617;
  display: inline-block;
  border-right: 2px solid #e293a0;
  padding-right: 4px;
  white-space: nowrap;
  animation: blink-caret 0.75s step-end infinite;
}

@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: #e293a0; }
}

.desktop-only {
  display: block;
}

/* --- DISEÑO RESPONSIVO (MÓVIL / TABLET) --- */
@media (max-width: 992px) {
  .hero-container-grid {
    grid-template-columns: 1fr;
    gap: 50px;
    text-align: center;
  }

  .hero-col-texto {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .hero-overlay {
    background: linear-gradient(180deg, rgba(11, 9, 10, 0.95) 50%, rgba(11, 9, 10, 0.8) 100%);
  }

  .desktop-only {
    display: none;
  }
}

@media (max-width: 576px) {
  .hero-fondo {
    padding: 60px 20px;
  }

  .hero-titulo {
    font-size: 2.4rem;
  }

  .hero-titulo-magic {
    font-size: 3rem;
  }

  .smartphone-device {
    width: 260px;
    height: 520px;
    border-width: 10px;
  }
  
  .mockup-url-wrapper {
    bottom: 20px;
    padding: 8px 12px;
  }
}
</style>